<template>
    <div v-if="loading" class="preloader-overlay">
        <div class="preloader-content">
            <div class="spinner-border text-primary mb-3" role="status">
                <span class="sr-only">Cargando...</span>
            </div>
            <h5 class="text-primary font-weight-bold">{{ title }}</h5>
            <p class="text-muted">{{ message }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoadingCompatibility',
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'Se están realizando las comparaciones necesarias de los productos'
        },
        message: {
            type: String,
            default: 'Por favor espere mientras se procesan los datos...'
        }
    }
};
</script>

<style scoped>
.preloader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.preloader-content {
    background: white;
    padding: 2rem;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    max-width: 400px;
    margin: 0 auto;
}

.spinner-border {
    width: 3rem;
    height: 3rem;
}
</style>
